import { render, staticRenderFns } from "./btnExcel.vue?vue&type=template&id=1f2a8981&"
import script from "./btnExcel.vue?vue&type=script&lang=js&"
export * from "./btnExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports